export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'aha' as string
export const OVERSIGHT_ENV_NAME = 'oversight'
export const GCS_ENV_NAME = 'aha'
export const SUBDOMAIN_SUFFIX = 'gcs'
